import React from "react";
import { Button, Grid } from "@mui/material";
import "components/pages/accountPreferences/list/AccountPreferenceList.css";

import AccountPreferenceTable from "components/pages/accountPreferences/list/table/AccountPreferenceTable";
import SubmitButton from "components/Button/SubmitButton";
import AccountFilter from "components/common/filters/account/AccountFilter";

import DiscardPreferenceModal from "components/pages/accountPreferences/modal/DiscardPreferenceModal";
import useAccountPreferenceList from "components/pages/accountPreferences/list/useAccountPreferenceList";
import EmptyTableData from "components/common/empty_data/EmptyTableData";
import EmptyContainer from "components/common/empty_container/EmptyContainer";
import Loading from "components/common/loading/Loading";

const AccountPreferenceList = () => {
  const {
    isRolePreference,
    isLoading,
    selectedAccount,

    preference,
    changeRole,
    setIsCancelPreference,
    isEditPreference,
    toggleAccount,

    cancelEdit,
    editPreferences,
    savePreferences,
    isCancelPreference,
    changeAccountPreference,

    discardAccountToggle,
    cancelAccountToggle,
  } = useAccountPreferenceList();

  return (
    <>
      <div className="preferences">
        <div className="preferences-container">
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            className="preferences-header"
          >
            <Grid item sm={3}>
              <AccountFilter
                displayAll={false}
                value={selectedAccount}
                onChange={changeAccountPreference}
              />
            </Grid>
            {isRolePreference && (
              <Grid
                item
                sm={6}
                className="d-flex"
                justifyContent="flex-end"
                spacing={2}
              >
                {isEditPreference ? (
                  <div className="button-group">
                    <Button
                      variant="outlined"
                      color="secondary"
                      className="preferences-edit-button"
                      onClick={() => setIsCancelPreference(true)}
                    >
                      Cancel
                    </Button>
                    <SubmitButton
                      buttonText="Save Preferences"
                      className="preferences-edit-button"
                      onClick={savePreferences}
                    />
                  </div>
                ) : (
                  <Button
                    variant="contained"
                    color="secondary"
                    className="preferences-edit-button"
                    onClick={editPreferences}
                    disabled={!selectedAccount}
                  >
                    Edit
                  </Button>
                )}
              </Grid>
            )}
          </Grid>
          {isLoading ? (
            <Loading />
          ) : (
            <Grid container>
              <Grid item xs={12} style={{ textAlign: "center" }}>
                {!selectedAccount ? (
                  <EmptyContainer
                    noDataText={
                      <div style={{ textAlign: "center" }}>
                        <h3 className="empty__title">
                          Select an account to proceed
                        </h3>
                        <p className="empty__content">
                          Please select an account from the dropdown to provide
                          user role access to features.
                        </p>
                      </div>
                    }
                  />
                ) : isRolePreference ? (
                  <AccountPreferenceTable
                    changeRole={changeRole}
                    isEditPreference={isEditPreference}
                    preference={preference}
                  />
                ) : (
                  <EmptyTableData />
                )}
              </Grid>
            </Grid>
          )}
        </div>

        {toggleAccount && (
          <DiscardPreferenceModal
            confirmCancel={discardAccountToggle}
            onCancel={cancelAccountToggle}
            showDiscardModal={toggleAccount}
          />
        )}

        {isCancelPreference && (
          <DiscardPreferenceModal
            confirmCancel={cancelEdit}
            onCancel={() => setIsCancelPreference(false)}
            showDiscardModal={isCancelPreference}
          />
        )}
      </div>
    </>
  );
};

export default AccountPreferenceList;
